import { render, staticRenderFns } from "./Peronal.vue?vue&type=template&id=0bad2dd3&"
import script from "./Peronal.vue?vue&type=script&lang=js&"
export * from "./Peronal.vue?vue&type=script&lang=js&"
import style0 from "./Peronal.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports